import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};

/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */
var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


export default retry;